import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import YachtsPage from "@/pages/YachtsPage";
import BrandPage from "@/pages/BrandPage";
import YachtDetailPage from "@/pages/YachtDetailPage";
import AdminPage from "@/pages/AdminPage";
import EnquiryPage from "@/pages/EnquiryPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsPage from "@/pages/TermsPage";
import { initPixel, trackPixel } from "@/lib/pixel";

function App() {
  const { pathname, state } = useLocation();
  const isAdmin = pathname.startsWith("/admin");

  useEffect(() => {
    if (!isAdmin) initPixel();
  }, [isAdmin]);

  useEffect(() => {
    if (!isAdmin && window.fbq && window.__pixelPath && window.__pixelPath !== pathname) trackPixel("PageView");
    window.__pixelPath = pathname;
  }, [pathname, isAdmin]);

  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) return;
    const lenis = new Lenis({ lerp: 0.08, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    if (state?.scrollTo) return;
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname, state]);

  return (
    <div className="bg-navy min-h-screen text-foreground" data-testid="app-root">
      {!isAdmin && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/yachts" element={<YachtsPage />} />
          <Route path="/yachts/:slug" element={<BrandPage />} />
          <Route path="/yachts/:slug/:yachtSlug" element={<YachtDetailPage />} />
          <Route path="/enquire" element={<EnquiryPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      <Toaster position="bottom-right" toastOptions={{
        style: { background: "#FFFFFF", border: "1px solid #E2DED4", color: "#12233B" },
      }} />
    </div>
  );
}

export default App;
